import { render, staticRenderFns } from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=template&id=71203d12&scoped=true"
import script from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=script&lang=js"
export * from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=style&index=0&id=71203d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71203d12",
  null
  
)

export default component.exports